import { Modal, Button, Form, Row, Col, InputGroup } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';
import ProductSelector from '../common/ProductSelector';

function PackagingMaterialModal({ show, onHide, material, onUpdated, isEdit = false }) {
    const [form, setForm] = useState({
        name: '',
        alias: '',
        size: '',
        weightOfBag: '',
        weightOfBagUnit: '',
        // weightPerBag: '',
        // weightUnit: '',
        itemWiseStuffing: [{ product: '', quantity: '', unit: '' }],
        reorderQuantity: '',
        reorderUnit: 'pcs',
        leadTimeInDays: '',
        isOuterPacking: false,
        outerPackingCapacity: ''
    });

    const reorderUnits = ['pcs', 'rolls'];
    const [units, setUnits] = useState([]);

    useEffect(() => {
        const fetchUnits = async () => {
            try {
                const unitsRes = await axios.get(`${config.API_BASE_URL}/units`);
                setUnits(unitsRes.data);
            } catch (err) {
                console.error("Failed to load units", err);
            }
        };
        fetchUnits();
    }, []);

    useEffect(() => {
        if (isEdit && material) {
            // Transform the material data for editing
            const transformedMaterial = {
                ...material,
                itemWiseStuffing: material.itemWiseStuffing?.map(item => ({
                    product: typeof item.product === 'object' ? item.product?._id : item.product,
                    quantity: item.quantity,
                    unit: item.unit
                })) || [{ product: '', quantity: '', unit: '' }]
            };
            setForm(transformedMaterial);
        }
    }, [material, isEdit, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleStuffingChange = (index, field, value) => {
        const updatedStuffing = [...form.itemWiseStuffing];
        updatedStuffing[index][field] = value;
        setForm(prev => ({ ...prev, itemWiseStuffing: updatedStuffing }));
    };

    const addStuffingRow = () => {
        setForm(prev => ({
            ...prev,
            itemWiseStuffing: [...prev.itemWiseStuffing, { product: '', quantity: '', unit: '' }]
        }));
    };

    const removeStuffingRow = (index) => {
        const updated = form.itemWiseStuffing.filter((_, i) => i !== index);
        setForm(prev => ({ ...prev, itemWiseStuffing: updated }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                await axios.put(`${config.API_BASE_URL}/packing-materials/${material._id}`, form);
                toast.success("Packaging material updated");
            } else {
                await axios.post(`${config.API_BASE_URL}/packing-materials/new`, form);
                toast.success("Packaging material added");
            }

            onUpdated();
            onHide();
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || "Operation failed");
        }
    };



    return (
        <Modal show={show} onHide={onHide} size="lg" fullscreen="lg-down">
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? "Edit" : "Add"} Packaging Material</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="gy-3">
                        <Col md={6}>
                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control name="name" value={form.name} onChange={handleChange} required />
                        </Col>
                        <Col md={6}>
                            <Form.Label>Alias <span className="text-danger">*</span></Form.Label>
                            <Form.Control name="alias" value={form.alias} onChange={handleChange} required />
                        </Col>
                        <Col md={6}>
                            <Form.Label>Dimensions of Packing Material <span className="text-danger">*</span></Form.Label>
                            <Form.Control name="size" value={form.size} onChange={handleChange} required />
                        </Col>
                        {/* <Col md={6}>
                            <Form.Label>Ideal Weight per Unit</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    name="weightPerBag"
                                    type="number"
                                    value={form.weightPerBag}
                                    onChange={handleChange}
                                />
                                <Form.Select
                                    value={form.weightUnit}
                                    onChange={(e) =>
                                        setForm(prev => ({ ...prev, weightUnit: e.target.value }))
                                    }
                                    style={{ maxWidth: '100px' }}
                                >
                                    {units.map(unit => (
                                        <option key={unit._id} value={unit.unitCode}>
                                            {unit.unitCode}
                                        </option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </Col> */}
                        <Col md={6}>
                            <Form.Label>Weight of the Bag</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    name="weightOfBag"
                                    type="number"
                                    value={form.weightOfBag}
                                    onChange={handleChange}
                                />
                                <Form.Select
                                    value={form.weightOfBagUnit}
                                    onChange={(e) =>
                                        setForm(prev => ({ ...prev, weightOfBagUnit: e.target.value }))
                                    }
                                    style={{ maxWidth: '100px' }}
                                >
                                    {units.map(unit => (
                                        <option key={unit._id} value={unit.unitCode}>
                                            {unit.unitCode}
                                        </option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Reorder Quantity</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    name="reorderQuantity"
                                    type="number"
                                    value={form.reorderQuantity}
                                    onChange={handleChange}
                                />
                                <Form.Select
                                    name="reorderUnit"
                                    value={form.reorderUnit}
                                    onChange={handleChange}
                                    style={{ maxWidth: '100px' }}
                                >
                                    {reorderUnits.map(unit => (
                                        <option key={unit} value={unit}>
                                            {unit}
                                        </option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Lead Time (in days)</Form.Label>
                            <Form.Control name="leadTimeInDays" type="number" value={form.leadTimeInDays} onChange={handleChange} />
                        </Col>

                        <Col md={12} className="mt-4">
                            <Form.Check
                                type="checkbox"
                                id="isOuterPacking-checkbox"
                                label="This is an outer packing material"
                                name="isOuterPacking"
                                checked={form.isOuterPacking || false}
                                onChange={(e) => setForm(prev => ({ ...prev, isOuterPacking: e.target.checked }))}
                            />
                        </Col>

                        <Col md={12}>
                            <Form.Label>Item-wise Stuffing</Form.Label>
                            {form.itemWiseStuffing.map((item, index) => (
                                <Row key={index} className="align-items-center mb-2 position-relative">
                                    <Col md={5}>
                                        <ProductSelector
                                            value={item.product}
                                            onChange={(productId) => {
                                                handleStuffingChange(index, 'product', productId || '');
                                            }}
                                            onProductChange={(selectedOption) => {
                                                handleStuffingChange(index, 'unit', selectedOption?.unit || '');
                                            }}
                                            placeholder="Select Product"
                                            isClearable
                                        />
                                    </Col>
                                    <Col md={5} style={{ position: 'relative' }}>
                                        <Form.Control
                                            placeholder="Quantity"
                                            type="number"
                                            value={item.quantity}
                                            onChange={e => handleStuffingChange(index, 'quantity', e.target.value)}
                                            required
                                        />
                                        {item.unit && (
                                            <span className="unit-suffix">
                                                {item.unit}
                                            </span>
                                        )}
                                    </Col>
                                    <Col md={2}>
                                        <Button variant="danger" size="sm" onClick={() => removeStuffingRow(index)}>X</Button>
                                    </Col>
                                </Row>
                            ))}
                            <Button variant="secondary" size="sm" onClick={addStuffingRow}>+ Add Item</Button>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Cancel</Button>
                    <Button type="submit" variant="primary">{isEdit ? "Update" : "Save"}</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default PackagingMaterialModal;
